module.exports = __webpack_public_path__ + "static/media/user-removed.493f646f.svg";